import React from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as CurrentPreparationStatusSVG } from "../../../../../../../../images/svg/public/order/current-preparation-status.svg";
import { ReactComponent as NextPreparationStatusSVG } from "../../../../../../../../images/svg/public/order/next-preparation-status.svg";
import { ReactComponent as PreparationStatusSVG } from "../../../../../../../../images/svg/public/order/preparation-status.svg";
import { OrderPreviewPreparationStatusName } from "../../../../../../../App/pages/Organization/pages/Sales/pages/Orders/services/types";

interface Props {
	status: OrderPreviewPreparationStatusName;
	lastElement: boolean;
	value: string | undefined;
	current: boolean;
}

const OrderPreparationStatus = ({ status, lastElement, value, current }: Props) => {
	const { t } = useTranslation();

	const getIcon = () => {
		if (current) return <CurrentPreparationStatusSVG />;
		if (value) return <PreparationStatusSVG />;
		return <NextPreparationStatusSVG />;
	};

	return (
		<div className="order-delivery-preparation-statuses-item">
			<div className="d-flex">
				<div className="status-container">
					{getIcon()}
					<div>
						{!lastElement && <div className={`item-separator ${current || !value ? "muted" : ""}`} />}
					</div>
				</div>
				<p className="mb-0 text-muted">{t(`enums.preparation_statuses.${status}`)}</p>
			</div>
		</div>
	);
};

export default OrderPreparationStatus;
